/*----------------------------------
- DEPENDANCES
----------------------------------*/

// Core
import ClientApplication from '@client/app';
import type { CoreError } from '@common/errors';

// Core Services
import Router from '@client/services/router';

// App Services
import MetricsService from '@/client/services/metrics';
import { buildSearchUrl } from '@/common/libs/filters';

/*----------------------------------
- TYPES
----------------------------------*/

/*----------------------------------
- APPLICATION
----------------------------------*/
export class UniqueDomains extends ClientApplication {

    /* TODO: How yo define services (func that need context) for back and frontend here ?
        Should we mix them with the fromtend only services ?
    */

    public Router = new Router(this, {
        preload: [],

        context: (context, router) => ({
            user: context.user || router.ssrContext.user
        }),
    })

    public metrics = new MetricsService(this);

    public boot(): void {

        // Tracking
        this.Router.on('page.changed', (page) => {
            this.metrics.pageView(page);
        });
    }

    public search( keywords?: string ) {

        const context = this.Router.context;

        keywords = keywords?.trim();
        if (!keywords)
            return this.toast.error("Please enter at least one keyword to search for domains.");

        this.Router.go( buildSearchUrl({ keywords }, this.Router, context), {}, { newTab: false });
    }

    public handleError(error: CoreError) {
        if (error.http === 401) {

            //this.upgrade({ feature: error.message });
            this.Router.go(401, { error: error.json() });
            
        } else {
            const message = ('render' in error && error.render) ? error.render() : error.message;
            this.toast.error( message, undefined, null, { autohide: false });
        }
    }
}

export default UniqueDomains